import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useMap } from '@vis.gl/react-google-maps';
import { ReactComponent as BluViuLogo } from 'assets/blu-viu-logo.svg';
import GoogleMaps from 'components/google-maps/google-maps';
import { useAccountState } from 'contexts/account/account-context';
import React, { useEffect } from 'react';
import { GoogleMapsMarkerInfo } from 'types/google-maps/google-maps-marker-info.type';
import LandingCarousel from './landing-carousel';
import LandingLinkBox from './landing-link-box';
import SiteMarker from './site-marker';

type LandingPageProps = {};

const MapGrid = styled(Grid)(({ theme }) => ({
  [`& .gm-style`]: {
    ['& .gm-style-iw']: {
      // info window styling
    },
    [`& .gm-style-iw-c`]: {
      [`& .gm-ui-hover-effect`]: {
        // override infowindow close button
        top: '-3px !important',
        right: '0px !important',
      },
    },
  },
}));

const LandingPage: React.FC<LandingPageProps> = ({}) => {
  const theme = useTheme();
  const map = useMap();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  const { account } = useAccountState();

  const markers: GoogleMapsMarkerInfo[] | undefined = account.company?.addressAccess
    .filter((a) => Number(a.latitude) !== 0 && Number(a.longitude) !== 0)
    .map((a) => ({
      lat: Number(a.latitude),
      lng: Number(a.longitude),
      url: a.isActive ? `${a.siteErpId}/${a.id}` : undefined,
      name: a.name,
    }));

  useEffect(() => {
    if (map) {
      if (!markers?.length) return;
      let bounds = new google.maps.LatLngBounds();

      markers?.forEach((item) => bounds.extend({ lat: item.lat, lng: item.lng }));

      map.fitBounds(bounds);
      map.panToBounds(bounds);
      map.setCenter({
        lat: bounds.getCenter().lat(),
        lng: bounds.getCenter().lng(),
      });
    }
  }, [markers, map]);

  return (
    <>
      <Box mb={isDesktop ? 32 : 16} mt={16} sx={{ display: 'flex', justifyContent: 'center' }}>
        {isDesktop ? <BluViuLogo width={'40%'} height={'40%'} /> : <BluViuLogo width={'70%'} height={'70%'} />}
      </Box>
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 4 }}>
          <LandingLinkBox />
        </Grid>
        <Grid size={{ xs: 12, md: 4 }} zIndex={0}>
          <LandingCarousel />
        </Grid>
        <MapGrid size={{ xs: 12, md: 4 }}>
          <GoogleMaps enableFullScreen>
            {markers?.map((marker, idx) => (
              <SiteMarker key={`marker_${idx}`} marker={marker} />
            ))}
          </GoogleMaps>
        </MapGrid>
      </Grid>
    </>
  );
};

export default React.memo(LandingPage);
